import './App.css';
//components
import Landing from './Components/Landing';
function App() {
    return (
        <div className="App">
            <Landing />
        </div>
    );
}

export default App;
